import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { toSignal } from '@angular/core/rxjs-interop';
import { BusinessFeeSettingsFirestorePaths } from '../../business-finances-general/business-finances-general.types';
import { TestHooks } from './idv-finances-general.hooks';

@Component({
	selector: 'app-idv-finances-general',
	templateUrl: './idv-finances-general.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdvFinancesGeneralComponent {
	testHooks = TestHooks;
	public settingsSignal = toSignal(
		inject(Store).select(BusinessState.getDefaultIdvFeeSettings),
	);

	private businessDispatch = inject(BusinessDispatch);

	public firestoreDefaultSettingsPath = BusinessFeeSettingsFirestorePaths.IDV;

	setAmount(amount: number): void {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${this.firestoreDefaultSettingsPath}.amount`,
			amount,
		);
	}
}
